import React, { useEffect, useState } from 'react';
import { DropdownMenu, DropLink } from '@eb/eds-dropdown-menu';

export default function DropdownMenuFallback(props) {
    const [isInBrowser, setIsInBrowser] = useState(false);

    useEffect(() => setIsInBrowser(true), []);

    return isInBrowser ? (
        <DropdownMenu {...props}>{props.children}</DropdownMenu>
    ) : (
        <DropLink>{props.children}</DropLink>
    );
}
